// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
} from 'recharts';

// Enums
import { SingleSelectQuestionDataType } from 'engagementReport/enums/propTypes';

// Utilities
import { rtlLanguage } from 'common/utils/helpers';

// Components
import CustomTooltip from 'admin/engagement/reporting/components/CustomTooltip';
import YAxisAutoScaleLabel from 'engagementReport/components/base/YAxisAutoScaleLabel';

const tooltipAttributes = [
  { tooltipLabel: 'Percentage', payloadKey: 'percentage', percentage: true },
  { tooltipLabel: 'Count', payloadKey: 'count' },
];

const SingleSelectHorizontalBarChart = ({ data, width }) => {
  if (!width) return null;

  // Increase the height to prevent the label overlying problem if got too many options
  const options = {};
  if (data.length > 10) {
    options.minHeight = data.length * 30;
  } else {
    options.aspect = 16 / 9;
  }

  return (
    <ResponsiveContainer {...options}>
      {/* eslint-disable react/no-array-index-key, react/prop-types */}
      <BarChart data={data} margin={{ top: 20, right: 30, bottom: 20 }} layout="vertical">
        <CartesianGrid horizontal={false} stroke="#e8e8e8" strokeWidth={1} />
        <Tooltip
          content={<CustomTooltip attributes={tooltipAttributes} />}
          cursor={{ fill: 'rgba(100, 100, 100, 0.05)' }}
          isAnimationActive={false}
        />
        <Bar
          dataKey="percentage"
          name="Percentage"
          background={{ fill: '#d6d6d6' }}
          barSize={20}
          unit="%"
        >
          {data.map((entry, index) => (
            <Cell key={index} fill={entry.top ? '#5b7d12' : '#4a90e2'} />
          ))}
        </Bar>
        <YAxis
          type="category"
          dataKey="label"
          tickLine={false}
          stroke="#636363"
          strokeWidth={1}
          interval={0}
          width={width * 0.3}
          fontSize={14}
          orientation={rtlLanguage() ? 'right' : 'left'}
          tick={<YAxisAutoScaleLabel parentWidth={width * 0.3} truncate={20} />}
        />
        <XAxis
          type="number"
          domain={[0, 100]}
          ticks={[0, 25, 50, 75, 100]}
          tickLine={false}
          unit="%"
          interval={0}
          axisLine={false}
        />
      </BarChart>
      {/* eslint-enable react/no-array-index-key, react/prop-types */}
    </ResponsiveContainer>
  );
};

SingleSelectHorizontalBarChart.propTypes = {
  data: SingleSelectQuestionDataType.isRequired,
  width: PropTypes.number,
};

SingleSelectHorizontalBarChart.defaultProps = {
  width: null,
};

export default SingleSelectHorizontalBarChart;
